import { createContext } from "react";

const TilemapContext = createContext()

export default TilemapContext
